// taken from https://git.perkbox.io/perkbox-services/regions/regions-app/-/blob/master/public/error_codes/codes.go

enum RegionErrorCodes {
  PBREGEmptyField = "PBREGEmptyField",
  PBREGIDAlreadyExists = "PBREGIDAlreadyExists",
  PBREGRegionNotFound = "PBREGRegionNotFound",
  PBREGHomepageNotFound = "PBREGHomepageNotFound",
  PBREGHomepageCategoryNotFound = "PBREGHomepageCategoryNotFound",
  PBREGHomepageCategoryInvalidKind = "PBREGHomepageCategoryInvalidKind",
  PBREGLimitExceeded = "PBREGLimitExceeded",
  PBREGInvalidRequest = "PBREGInvalidRequest"
}

export default RegionErrorCodes
